import { useEffect, useState } from 'react';
import CustomAppBar from '../../components/CustomAppBar';
import { Box, Button, Card, CircularProgress, Container, Grid, IconButton, Typography, useTheme } from "@mui/material";
import { GraphicEq, PlayArrow } from '@mui/icons-material';
import { connect, useDispatch } from 'react-redux';
import { authActions } from '../../store/reducer/auth-reducer';
import { homePageActions } from '../../store/reducer/home';
import { useNavigate, useNavigation, useParams } from 'react-router-dom';
import { ReactComponent as DiceIcon } from '../../assets/onedice.svg';
import { ReactComponent as TwoDice } from '../../assets/twodice.svg';

import { ReactComponent as SinglePan } from '../../assets/singlepanna.svg';
import { ReactComponent as DoublePan } from '../../assets/doublepanna.svg';
import { ReactComponent as TripplePan } from '../../assets/tripplepanna.svg';
import { gameNumbers } from './gameConstants';
import AlertBar from '../../components/AlertBar';
import { starlineActions } from '../../store/reducer/starline';
import { isEmpty } from 'lodash';

const styles: any = {
    iconStyle: {
        height: '40px',
        width: '40px',
        '@media (max-width: 600px)': {
            height: '36px',
            width: '36px'
        }
    }
}

const incoList: any = {
    'single_digit': { component: <DiceIcon style={styles.iconStyle} />, name: 'Single Digit' },
    'single_digit_bulk': { component: <div style={{ display: 'flex', gap: '4px' }}><DiceIcon style={styles.iconStyle} /><DiceIcon style={styles.iconStyle} /></div>, name: 'Single Digit Bulk' },
    'jodi_digit': { component: <TwoDice style={styles.iconStyle} />, name: 'Jodi Digit' },
    'single_pana': { component: <SinglePan style={styles.iconStyle} />, name: 'Single Panna' },
    'single_pana_bulk': { component: <div style={{ display: 'flex', gap: '4px' }}><SinglePan style={styles.iconStyle} /><SinglePan style={styles.iconStyle} /></div>, name: 'Single Pana Bulk' },
    'sp_motor': { component: <SinglePan style={styles.iconStyle} />, name: 'SP Motor' },
    'double_pana': { component: <DoublePan style={styles.iconStyle} />, name: 'Double Panna' },
    'double_pana_bulk': { component: <div style={{ display: 'flex', gap: '4px' }}><DoublePan style={styles.iconStyle} /><DoublePan style={styles.iconStyle} /></div>, name: 'Double Pana Bulk' },
    'dp_motor': { component: <DoublePan style={styles.iconStyle} />, name: 'DP Motor' },
    'tripple_pana': { component: <TripplePan style={styles.iconStyle} />, name: 'Tripple Panna' },
    'all_sp_dp_tp': { component: <div style={{ display: 'flex', gap: '2px' }}><SinglePan style={styles.iconStyle} /><DoublePan style={styles.iconStyle} /><TripplePan style={styles.iconStyle} /></div>, name: 'All SP DP TP' },
    'half_sangam': { component: <div style={{ display: 'flex' }}><DiceIcon style={styles.iconStyle} /><SinglePan style={styles.iconStyle} /></div>, name: 'Half Sangam' },
    'full_sangam': { component: <div style={{ display: 'flex' }}><DiceIcon style={styles.iconStyle} /><TripplePan style={styles.iconStyle} /></div>, name: 'Full Sangam' }
}



const GamePlay = ({ homePageData, gameData, isGameLoading, isCheckGameStatusSuccess, gameStatusData }: any) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { game_id } = useParams();
    const theme = useTheme();
    const [gameList, setGameList] = useState<any>([])
    const nav = useNavigation()
    const [gameStatusList, setGameStatusList] = useState<any>({ open_time: '', close_time: '' })
    const [errorMessage, setErrorMessage] = useState<any>({ status: false, message: '', severity: '', inputName: '' })

    useEffect(() => {
        const gamePayload: any = {
            app_key: "@34Y@#8deepmatka",
            user_id: 27,
            player_id: 27
        };
        dispatch(homePageActions.dashboardDataRequest(gamePayload))
        const pay: any = {
            menuname: 'gamelist'
        }
        dispatch(homePageActions.selectedMenu(pay))
    }, [])

    useEffect(() => {
        if (!isEmpty(homePageData)) {
            const _homepagedata = homePageData.result.filter((item: any) => item.game_id == game_id)[0];
            const name: any = _homepagedata.game_name
            dispatch(starlineActions.setMenuHeaderName(name))
        }

        const data: any = {
            app_key: "@34Y@#8deepmatka",
            game_id: game_id
        };

        dispatch(homePageActions.gameDataRequest(data))
        dispatch(homePageActions.checkGameStatusReq(data))


    }, [game_id, homePageData])


    useEffect(() => {
        if (isCheckGameStatusSuccess) {
            if (Object.keys(gameStatusData).length > 0) {
                if (checkTime(gameStatusData.open_time, gameStatusData.close_time, 'close')) {
                    navigate('/home')
                } else {
                    setGameStatusList(gameStatusData)
                }
            } else {
                navigate('/home')
            }
        }
    }, [isCheckGameStatusSuccess, gameStatusData])

    useEffect(() => {
        if (Object.keys(gameData).length > 0) {
            let temp: any = []
            gameData.game_rates.forEach((element: any) => {
                let data: any = Object.keys(element);
                let filterdata = data.filter((item: any) => {
                    if (item != 'game_rate_id' && item != 'insert_date') {
                        let searchString = item.split('_')[0] + '_' + item.split('_')[1]
                        if (temp.length) {
                            if (!temp.includes(item.match(searchString)[0])) {
                                temp.push(item.match(searchString)[0])
                            }
                        } else {
                            temp.push(item.match(searchString)[0])
                        }

                    }
                    return item
                });

            });
            // Add single_digit_bulk if single_digit exists (manually add bulk option)
            if (temp.includes('single_digit') && !temp.includes('single_digit_bulk')) {
                temp.push('single_digit_bulk')
            }
            // Add single_pana_bulk if single_pana exists (manually add bulk option)
            if (temp.includes('single_pana') && !temp.includes('single_pana_bulk')) {
                temp.push('single_pana_bulk')
            }
            // Add double_pana_bulk if double_pana exists (manually add bulk option)
            if (temp.includes('double_pana') && !temp.includes('double_pana_bulk')) {
                temp.push('double_pana_bulk')
            }
            // Add all_sp_dp_tp if any of single_pana, double_pana, or tripple_pana exists
            if ((temp.includes('single_pana') || temp.includes('double_pana') || temp.includes('tripple_pana')) && !temp.includes('all_sp_dp_tp')) {
                temp.push('all_sp_dp_tp')
            }
            // Add sp_motor if single_pana exists (manually add SP Motor option)
            if (temp.includes('single_pana') && !temp.includes('sp_motor')) {
                temp.push('sp_motor')
            }
            // Add dp_motor if double_pana exists (manually add DP Motor option)
            if (temp.includes('double_pana') && !temp.includes('dp_motor')) {
                temp.push('dp_motor')
            }
            setGameList(temp)
        }
    }, [gameData])

    const gotoPlaceBid = (event: any, item: any) => {
        if (item === 'jodi_digit' || item === 'half_sangam' || item === 'full_sangam') {
            if (checkTime(gameStatusData.open_time, gameStatusData.close_time, 'open')) {
                setErrorMessage({ status: true, message: "Bid is closed for today, Session expired.", severity: "error", inputName: '' })
            } else {
                navigate('/play-game/place-bid/' + game_id + '/' + gameNumbers[item])
            }
        } else {
            navigate('/play-game/place-bid/' + game_id + '/' + gameNumbers[item])
        }
    }

    const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setErrorMessage({ status: false, message: "", severity: "", inputName: '' })
    };

    function checkTime(opentime: any, closetime: any, req: any) {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();
        var todayDate = mm + '/' + dd + '/' + yyyy;
        const startTimeHours = new Date(todayDate + ' ' + opentime).getHours();
        const startTimeMin = new Date(todayDate + ' ' + opentime).getMinutes()
        const endTimeHours = new Date(todayDate + ' ' + closetime).getHours();
        const endTimeMin = new Date(todayDate + ' ' + closetime).getMinutes()
        var currentD = today;
        var startHappyHourD = new Date();
        startHappyHourD.setHours(startTimeHours, startTimeMin, 0); // 10:00 pm
        var endHappyHourD = new Date();
        endHappyHourD.setHours(endTimeHours, endTimeMin, 0); // 10.00 pm
        if (req === 'open') {
            if (currentD >= startHappyHourD) {
                return true
            } else {
                return false
            }
        } else if (req === 'close') {
            if (currentD >= endHappyHourD) {
                return true
            } else {
                return false
            }
        }
    }
    return (
        <div style={{ flex: 1, width: '100%', marginTop: '0px', backgroundColor: theme.palette.background.default, minHeight: '100vh' }}>
            {isGameLoading ? <div style={{ width: '100%', height: '30vh', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}> <CircularProgress sx={{ color: theme.palette.primary.main }} /> </div> :
            <Container sx={{ 
                paddingLeft: { xs: '10px', sm: '15px', md: '20px', lg: '20px' }, 
                paddingRight: { xs: '10px', sm: '15px', md: '20px', lg: '20px' }, 
                marginTop: '0px !important', 
                backgroundColor: 'transparent',
                paddingTop: { xs: '15px', sm: '20px', md: '25px', lg: '30px' },
                paddingBottom: { xs: '80px', sm: '80px', md: '30px', lg: '30px' },
            }}>
                <AlertBar handleClose={handleClose} errorMessage={errorMessage} />
                <Box sx={{ 
                    marginBottom: '25px',
                    textAlign: 'center',
                }}>
                    <Typography sx={{
                        fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
                        fontWeight: '700',
                        color: theme.palette.primary.main,
                        fontFamily: 'Poppins',
                        background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        letterSpacing: '0.5px',
                        marginBottom: '10px',
                    }}>
                        Select Game Type
                    </Typography>
                </Box>
                <Grid container spacing={{ xs: 2, sm: 2, md: 3, lg: 3 }} sx={{
                    display: 'flex',
                    justifyContent: { xs: 'center', sm: 'flex-start', md: 'flex-start' },
                }}>
                    {gameList.map((item: any, index: number) => (
                        <Grid item xs={6} sm={4} md={3} lg={2} key={`game-${index}`}>
                            <Card 
                                onClick={(event: any) => {
                                    gotoPlaceBid(event, item)
                                }} 
                                sx={{
                                    borderRadius: '20px',
                                    backgroundColor: theme.palette.background.paper,
                                    boxShadow: '0 4px 20px rgba(74, 144, 226, 0.12)',
                                    border: `1px solid ${theme.palette.divider}`,
                                    minHeight: { xs: '140px', sm: '150px', md: '160px' },
                                    cursor: 'pointer',
                                    padding: { xs: '20px 15px', sm: '25px 20px', md: '30px 25px' },
                                    gap: 2,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    textTransform: 'capitalize',
                                    position: 'relative',
                                    overflow: 'hidden',
                                    '&::before': {
                                        content: '""',
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        height: '4px',
                                        background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                                        opacity: 0,
                                        transition: 'opacity 0.3s ease',
                                    },
                                    '&:hover': {
                                        transform: 'translateY(-8px)',
                                        boxShadow: '0 8px 30px rgba(74, 144, 226, 0.25)',
                                        borderColor: theme.palette.primary.light,
                                        backgroundColor: theme.palette.background.paper,
                                        '&::before': {
                                            opacity: 1,
                                        },
                                    },
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                }}
                            >
                                <Box sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    marginBottom: '10px',
                                    '& svg': {
                                        filter: 'drop-shadow(0 2px 4px rgba(74, 144, 226, 0.2))',
                                        transition: 'transform 0.3s ease',
                                    },
                                    '&:hover svg': {
                                        transform: 'scale(1.1)',
                                    },
                                }}>
                                    {incoList[item]['component']}
                                </Box>
                                <Typography 
                                    variant='h6' 
                                    sx={{
                                        textAlign: 'center',
                                        color: theme.palette.primary.main,
                                        fontFamily: 'Poppins',
                                        fontSize: { xs: '0.95rem', sm: '1rem', md: '1.1rem' },
                                        fontWeight: '700',
                                        lineHeight: 1.2,
                                        background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                                        WebkitBackgroundClip: 'text',
                                        WebkitTextFillColor: 'transparent',
                                    }}
                                >
                                    {incoList[item]['name']}
                                </Typography>
                            </Card>
                        </Grid>
                    ))}
                    {['sp','dp','tp'].map((item:any, index: number) => (
                        <Grid item xs={6} sm={4} md={3} lg={2} key={`pan-${index}`}>
                            <Card 
                                onClick={(event: any) => {
                                    gotoPlaceBid(event, (item==='sp') ? 'single_pana' : (item==='dp') ? 'double_pana' : 'tripple_pana')
                                }} 
                                sx={{
                                    borderRadius: '20px',
                                    backgroundColor: theme.palette.background.paper,
                                    boxShadow: '0 4px 20px rgba(74, 144, 226, 0.12)',
                                    border: `1px solid ${theme.palette.divider}`,
                                    minHeight: { xs: '140px', sm: '150px', md: '160px' },
                                    cursor: 'pointer',
                                    padding: { xs: '20px 15px', sm: '25px 20px', md: '30px 25px' },
                                    gap: 2,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    textTransform: 'uppercase',
                                    position: 'relative',
                                    overflow: 'hidden',
                                    '&::before': {
                                        content: '""',
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        height: '4px',
                                        background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                                        opacity: 0,
                                        transition: 'opacity 0.3s ease',
                                    },
                                    '&:hover': {
                                        transform: 'translateY(-8px)',
                                        boxShadow: '0 8px 30px rgba(74, 144, 226, 0.25)',
                                        borderColor: theme.palette.primary.light,
                                        backgroundColor: theme.palette.background.paper,
                                        '&::before': {
                                            opacity: 1,
                                        },
                                    },
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                }}
                            >
                                <Box sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    marginBottom: '10px',
                                    '& svg': {
                                        filter: 'drop-shadow(0 2px 4px rgba(74, 144, 226, 0.2))',
                                        transition: 'transform 0.3s ease',
                                    },
                                    '&:hover svg': {
                                        transform: 'scale(1.1)',
                                    },
                                }}>
                                    {(item==='sp') ? incoList["single_pana"]['component'] : (item==='dp') ? incoList["double_pana"]['component'] : incoList["tripple_pana"]['component']}
                                </Box>
                                <Typography 
                                    variant='h6' 
                                    sx={{
                                        textAlign: 'center',
                                        textTransform: 'uppercase',
                                        color: theme.palette.primary.main,
                                        fontFamily: 'Poppins',
                                        fontSize: { xs: '1rem', sm: '1.1rem', md: '1.2rem' },
                                        fontWeight: '700',
                                        lineHeight: 1.2,
                                        background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                                        WebkitBackgroundClip: 'text',
                                        WebkitTextFillColor: 'transparent',
                                    }}
                                >
                                    {item}
                                </Typography>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>}
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    gameData: state.homepage.gameData,
    isGameLoading: state.homepage.isGameLoading,
    isCheckGameStatusLoading: state.homepage.isCheckGameStatusLoading,
    gameStatusData: state.homepage.gameStatusData,
    isCheckGameStatusFailed: state.homepage.isCheckGameStatusFailed,
    isCheckGameStatusSuccess: state.homepage.isCheckGameStatusSuccess,
    homePageData: state.homepage.homePageData,
})


export default connect(mapStateToProps)(GamePlay);